/**
 * Reset do contador da Semana da Fisioterapia.
 * A oferta zera todos os dias às 23h59 (horário de Brasília) e reinicia.
 * Compartilhado entre o catálogo e as LPs de produto da ação.
 */

/** Reset diário: todos os dias da semana. */
export const RESET_WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

export function msUntilNextResetBRT(): number {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Sao_Paulo",
    hourCycle: "h23",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(new Date());
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "0";
  const elapsed = Number(get("hour")) * 3600 + Number(get("minute")) * 60 + Number(get("second"));

  const LAST_SECOND = 86399; // 23:59:59
  const remaining = LAST_SECOND - elapsed;
  return (remaining > 0 ? remaining : remaining + 86400) * 1000;
}
